export const API_ERROR = "api_failed";
export const MATERIALREQUEST_PENDING_LIST = "MR_pending_list";
export const MATERIALREQUEST_PENDING_LIST_SUCCESS = "MR_pending_list_success";

// export const MATERIALREQUEST_ROW_LIST = "MR_row_list";
// export const MATERIALREQUEST_ROW_LIST_SUCCESS = "MR_pending_row_success";

export const MR_MODEL_LIST_OPEN = "MR_model_open";
export const MR_MODEL_LIST_CLOSE = "MR_model_close";
export const ALL_MR_ITEMS_CHECKED = "MR_all_Items_checked";
export const MR_ITEMS_CHECKED = "mr_item_checked";
export const MR_SELECT_ITEM = "mr_select_Item";

export const PI_SELECTED_ITEM = "PI_Selected_Item";
export const ADD_TO_SELECTED_ITEM = "PI_add_to_Selected_Item";

export const PURCHASEINDENT_LIST = "purchaseindent_list";
export const MY_PURCHASEINDENT_LIST = "my_purchaseindent_list";
export const MY_PURCHASEINDENT_LIST_SUCCESS = "my_purchaseindent_list_success";
export const MY_PI_LIST_COUNT = "my_pi_list_count";
export const PI_LIST_COUNT = "pi_list_count";
export const PI_LIST_COUNT_SUCCESS = "my_pi_list_count_success";

export const PI_PRODUCTS_REQUEST_LIST = "pi_products_request_list";
export const PI_PRODUCTS_REQUEST_LIST_SUCCESS =
  "pi_products_request_list_success";
export const PRODUCTS_ROW_REQUEST = "pi_products_Row_request";
export const PRODUCTS_ROW_REQUEST_SUCCESS = "pi_products_Row_request_success";

export const INPUT_CHANGEVALUE = "pi_input_ChangeValue";
export const SELECT_CHANGEVALUE = "pi_Select_ChangeValue";

export const SI_INPUT_CHANGEVALUE = "SI_input_ChangeValue";
export const SI_SELECT_CHANGEVALUE = "SI_Select_ChangeValue";
export const REMOVE_SELECTED_PRODUCT = "remove_selected_product";

export const SET_PARAMS = "pi_set_params";
export const FILTER_INPUT_CHANGEVALUE = "pi_Filter_input_ChangeValue";
export const FILTER_SELECT_CHANGEVALUE = "pi_Filter_Select_ChangeValue";

export const PI_MODEL_LIST_OPEN = "pIlistItem_model_open";
export const PI_MODEL_LIST_CLOSE = "pIlistItem_model_close";

export const PRODUCT_MODEL_OPEN = "product_model_open";
export const PRODUCT_MODEL_CLOSE = "product_model_close";

export const PURCHASEINDENT_ADD = "purchaseindent_add";

export const PURCHASEINDENT_ROW = "purchaseindent_row";
export const PURCHASEINDENT_ROW_SUCCESS = "purchaseindent_row_success";

export const PI_ITEM_HOD_APPROVAL = "pi_itemHodApproval";
// export const PII_DEPT_HOD_APPROVAL = "pii_Dept_HodApproval";

export const PI_ROW_LOADING = "pi_Row_loading";
export const PI_HOD_APPROVE_ADD = "pi_hod_approve_add";
export const PURCHASEINDENT_DELETE = "purchaseindent_delete";
export const TOGGLE_ITEM_MENU = "toggle_item_menu";

export const MODEL_OPEN = "addItem_model_open";
export const MODEL_CLOSE = "addItem_model_close";
export const LIST_LAYOUT = "pi_list_layout";

export const MR_DETAILS_MODEL_OPEN = "pi_mr_details_model_open";
export const MR_DETAILS_MODEL_CLOSE = "pi_mr_details_model_close";
export const MATERIALREQUEST_ROW_DATA_SUCCESS = "pi_mr_row_data";

export const FILTERS_SHOW_RIGHT_SIDEBAR = "pi_filter_show_right_sidebar";
export const FILTERS_HIDE_RIGHT_SIDEBAR = "pi_filter_hide_right_sidebar";
export const CLEAR_FILTER = "pi_clear_filter";

export const PRODUCT_STORE_QTY = "pi_getProductStoreQty";
export const PRODUCT_STORE_QTY_SUCCESSFUL = "pi_getProductStoreQtySuccessful";

export const PI_MR_ITEM_IMAGES = "PO_PI_MR_Item_Images";
export const PI_MR_ITEM_IMAGES_SUCCESS = "PO_PI_MR_Item_Images_Success";

export const PRODUCT_ITEM_HISTORY_MODEL_OPEN =
  "PI_product_Item_history_modelOpen";
export const PRODUCT_ITEM_HISTORY_MODEL_CLOSE =
  "PI_product_Item_history_modelClose";
